import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AgricolaClientSearchComponent } from '../components/agricola/agricola-client-search/agricola-client-search.component';
import { AgricolaConsultasComponent } from '../components/agricola/agricola-consultas/agricola-consultas.component';
import { AgricolaPolicyDetailComponent } from '../components/agricola/agricola-policy-detail/agricola-policy-detail.component';
import { AgricolaDashboardComponent } from '../components/agricola/agricola-dashboard/agricola-dashboard.component';
import { AgricolaLoginComponent } from '../components/agricola/agricola-login/agricola-login.component';
import { AgricolaPolicyWizardComponent } from '../components/agricola/agricola-policy-wizard/agricola-policy-wizard/agricola-policy-wizard.component';
import { AgricolaReportQueueComponent } from '../components/agricola/agricola-report-queue/agricola-report-queue.component';
import { AgricolaReportesComponent } from '../components/agricola/agricola-reportes/agricola-reportes.component';
import { AgricolaSellReportComponent } from '../components/agricola/agricola-sell-report/agricola-sell-report.component';
import { PublicPaymentFormComponent } from '../components/public-payment/public-payment-form/public-payment-form.component';
import { AuthGuardService } from './guards/auth-guard.service';
import { agricolaWizardExitGuard } from './guards/agricola-wizard-exit.guard';

const routes: Routes = [
  {
    path: 'login',
    component: AgricolaLoginComponent
  },
  {
    // Public customer signature page — no guard (like login). Reached from the
    // private link the seller sends; loads its own read-only sale data.
    path: 'public/assistance-insurance-payment',
    component: PublicPaymentFormComponent
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: 'agricola',
    canActivate: [AuthGuardService],
    component: AgricolaDashboardComponent
  },
  {
    path: 'agricola/dashboard',
    canActivate: [AuthGuardService],
    component: AgricolaDashboardComponent
  },
  {
    path: 'agricola/client-search',
    canActivate: [AuthGuardService],
    component: AgricolaClientSearchComponent
  },
  {
    path: 'agricola/form-client',
    canActivate: [AuthGuardService],
    canDeactivate: [agricolaWizardExitGuard],
    component: AgricolaPolicyWizardComponent
  },
  {
    path: 'agricola/policy-queries',
    canActivate: [],
    component: AgricolaConsultasComponent
  },
  {
    path: 'agricola/policy-detail/:policyNumber',
    canActivate: [AuthGuardService],
    component: AgricolaPolicyDetailComponent
  },
  {
    path: 'agricola/reportes',
    canActivate: [AuthGuardService],
    component: AgricolaReportesComponent
  },
  {
    path: 'agricola/reportes/ventas',
    canActivate: [AuthGuardService],
    component: AgricolaSellReportComponent
  },
  {
    path: 'agricola/reportes/cola',
    canActivate: [AuthGuardService],
    component: AgricolaReportQueueComponent
  },
  {
    path: '**',
    redirectTo: 'agricola'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      bindToComponentInputs: true,
      scrollPositionRestoration: 'top'
    })
  ],
  exports: [RouterModule]
})
export class RoutesModule {}
